/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'moreicon': {
    width: 5,
    height: 23,
    viewBox: '0 0 5 23',
    data: '<g transform="translate(.23 .166)" fill-rule="evenodd"><circle pid="0" cx="2.278" cy="2.278" r="2.278"/><circle pid="1" cx="2.278" cy="20.383" r="2.278"/><circle pid="2" cx="2.278" cy="11.246" r="2.278"/></g>'
  }
})
